const VPIC_BASE_URL = "https://vpic.nhtsa.dot.gov/api/vehicles";

const requestJson = async (url) => {
  const response = await fetch(url);

  if (!response.ok) {
    throw new Error(`Vehicle API request failed with status ${response.status}`);
  }

  const data = await response.json();
  return Array.isArray(data?.Results) ? data.Results : [];
};

const normalizeOptionLabel = (value) => (value ? String(value).trim() : "");

export const getYearOptions = (count = 40) => {
  const currentYear = new Date().getFullYear() + 1;
  return Array.from({ length: count }, (_, index) => String(currentYear - index));
};

export const fetchVehicleMakes = async () => {
  const results = await requestJson(
    `${VPIC_BASE_URL}/GetMakesForVehicleType/car?format=json`
  );

  return results
    .map((item) => normalizeOptionLabel(item.MakeName))
    .filter(Boolean)
    .sort((a, b) => a.localeCompare(b));
};

export const fetchVehicleModels = async (year, make) => {
  if (!year || !make) {
    return [];
  }

  const results = await requestJson(
    `${VPIC_BASE_URL}/GetModelsForMakeYear/make/${encodeURIComponent(
      make
    )}/modelyear/${encodeURIComponent(year)}?format=json`
  );

  return results
    .map((item) => normalizeOptionLabel(item.Model_Name))
    .filter(Boolean)
    .sort((a, b) => a.localeCompare(b));
};

export const formatVehicleLabel = ({ year, make, model }) =>
  [normalizeOptionLabel(year), normalizeOptionLabel(make), normalizeOptionLabel(model)]
    .filter(Boolean)
    .join(" ");

export const sanitizeYearInput = (value) =>
  String(value || "")
    .replace(/\D/g, "")
    .slice(0, 4);

export const sanitizeVinInput = (value) =>
  String(value || "")
    .toUpperCase()
    .replace(/[^A-HJ-NPR-Z0-9]/g, "")
    .slice(0, 17);
